import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import teamMemberService from "../../services/teamMember/teamMemberService";
import sweetAlert from "../../utils/sweetAlert";
import { toast } from "react-toastify";


export default function TeamMemberList() {

    const [teamMember, setTeamMember] = useState([]);

    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);

    const [pageSize] = useState(10);

    const [search, setSearch] = useState("");

    const [totalPages, setTotalPages] = useState(0);


    useEffect(() => {

        loadTeamMember();

    }, [page, search]);


    const loadTeamMember = async () => {

        try {

            setLoading(true);

            const response = await teamMemberService.getList(
                page,
                pageSize,
                search
            );

            if (response.success) {

                setTeamMember(response.data.items);

                setTotalPages(response.data.totalPages);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Failed to load team members.");

        }
        finally {

            setLoading(false);

        }

    };


    const handleDelete = async (id) => {

        const confirmed = await sweetAlert.confirmDelete();

        if (!confirmed) {

            return;

        }

        try {

            const response = await teamMemberService.delete(id);

            if (response.success) {

                toast.success(response.message);

                loadTeamMember();

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }

    };


    return (

        <AdminLayout>

            <div className="page-header">

                <h2>Team Members</h2>

                <Link
                    to="/team-members/add"
                    className="btn btn-primary"
                >
                    Add Team Member
                </Link>

            </div>


            {/* Search */}
            <div className="d-flex mb-3 gap-2">

                <input
                    type="text"
                    className="form-control"
                    placeholder="Search team member..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />

                <button
                    className="btn btn-primary"
                    disabled={loading}
                    onClick={() => setPage(1)}
                >
                    Search
                </button>

            </div>


            <div className="card">

                <div className="card-body">

                    <table className="table table-bordered">

                        <thead>

                            <tr>

                                <th>Photo</th>

                                <th>Member Name</th>

                                <th>Designation</th>

                                <th>Qualification</th>

                                <th>Status</th>

                                <th>Action</th>

                            </tr>

                        </thead>


                        <tbody>

                            {

                                loading ?

                                    <tr>

                                        <td
                                            colSpan="6"
                                            className="text-center"
                                        >
                                            Loading...
                                        </td>

                                    </tr>

                                    :

                                    teamMember.length === 0 ?

                                        <tr>

                                            <td
                                                colSpan="6"
                                                className="text-center"
                                            >
                                                No Team Members Found
                                            </td>

                                        </tr>

                                        :

                                        teamMember.map(item => (

                                            <tr key={item.memberId}>

                                                {/* Photo */}
                                                <td style={{ width: "90px" }}>

                                                    {
                                                        item.photo ?

                                                            <img
                                                                src={`${process.env.REACT_APP_SERVER_URL}${item.photo}`}
                                                                alt={item.memberName}
                                                                className="img-thumbnail"
                                                                style={{
                                                                    width: "70px",
                                                                    height: "70px",
                                                                    objectFit: "cover"
                                                                }}
                                                            />

                                                            :

                                                            "-"
                                                    }

                                                </td>


                                                {/* Name */}
                                                <td>
                                                    {item.memberName}
                                                </td>


                                                {/* Designation */}
                                                <td>
                                                    {item.designation || "-"}
                                                </td>


                                                {/* Qualification */}
                                                <td>
                                                    {item.qualification || "-"}
                                                </td>


                                                {/* Status */}
                                                <td>

                                                    {
                                                        item.isActive

                                                            ? (
                                                                <span className="badge bg-success">
                                                                    Active
                                                                </span>
                                                            )

                                                            : (
                                                                <span className="badge bg-danger">
                                                                    Inactive
                                                                </span>
                                                            )
                                                    }

                                                </td>


                                                {/* Actions */}
                                                <td>

                                                    <Link
                                                        to={`/team-members/edit/${item.memberId}`}
                                                        className="btn btn-warning btn-sm me-2"
                                                    >
                                                        Edit
                                                    </Link>


                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() =>
                                                            handleDelete(item.memberId)
                                                        }
                                                    >
                                                        Delete
                                                    </button>

                                                </td>

                                            </tr>

                                        ))

                            }

                        </tbody>

                    </table>

                </div>

            </div>

        </AdminLayout>

    );

}